import {Auth} from '../services/core'
import {Customer} from '../services/SOLO'

export default {
  sidebarOpen: false,
  sidebarContainerRow: 4,
  rootRowHeight: 1,
  AuthService: Auth,
  customerService: Customer  
}